import { wait } from "../../utils/mock";

export const mockJh = {
    id: "uuid-1",
    displayName: "Hrabal Jan",
    firstName: "Jan",
    surname: "Hrabal",
};

export const fetchEmployeeList = async (filter) => {
    console.log("fetching employees", filter);
    await wait(1450);
    const items = [];
    for (let i = 0; i < 48; i++) {
        items.push({ ...mockJh, id: `uuid-${i * 2}` });
        //items.push({ ...mockExpense, id: `expense-${i}` });
    }

    return {
        isFirst: true,
        hasMore: false,
        items,
    };
};

export const fetchEmployeeOverview = async ({ filter }) => {
    console.log("fetching overview", filter);
    await wait(1234);
    return {
        currencyCode: "CZK",
        totals: {
            currencyCode: "CZK",
            balance: {
                current: 1789000,
                previous: 1600000,
                diffPercent: 12,
            },
            income: {
                current: 2200000,
                previous: 1900000,
                diffPercent: 9,
            },
            expenditure: {
                current: 580000,
                previous: 500000,
                diffPercent: 16,
            },
        },
        cashflow: {
            currencyCode: "CZK",
            data: [
                {
                    name: "M-2023-01",
                    values: {
                        uuid1: 12000,
                        uuid2: 6500,
                        uuid3: 12000,
                        uuid5: 105900,
                    },
                },
                {
                    name: "M-2023-02",
                    values: {
                        uuid1: -184000,
                        uuid2: 3200,
                        uuid3: 12000,
                        uuid5: 5900,
                    },
                },
                {
                    name: "M-2023-03",
                    values: {
                        uuid1: 205000,
                        uuid2: 3200,
                        uuid3: 12000,
                        uuid5: 305900,
                    },
                },
                {
                    name: "M-2023-04",
                    values: {
                        uuid1: 184000,
                        uuid2: 3200,
                        uuid0: 75000,
                        uuid3: 87000,
                        uuid5: 39000,
                    },
                },
                {
                    name: "M-2023-05",
                    values: {
                        uuid1: 192000,
                        uuid2: 6500,
                        uuid3: 12000,
                        uuid5: 5900,
                    },
                },
                {
                    name: "M-2023-06",
                    values: {
                        uuid1: 184000,
                        uuid2: 2400,
                        uuid0: 35000,
                        uuid3: 12000,
                        uuid5: 5900,
                    },
                },
                {
                    name: "M-2023-07",
                    values: {
                        uuid1: 192000,
                        uuid2: 6500,
                        uuid3: 12000,
                        uuid5: 5900,
                    },
                },
                {
                    name: "M-2023-08",
                    values: {
                        uuid1: 184000,
                        uuid2: 3200,
                        uuid3: 12000,
                        uuid5: 5900,
                    },
                },
                {
                    name: "M-2023-09",
                    values: {
                        uuid1: 205000,
                        uuid2: 3200,
                        uuid3: 12000,
                        uuid5: 5900,
                    },
                },
                {
                    name: "M-2023-10",
                    values: {
                        uuid1: 220000,
                        uuid2: 3200,
                        uuid0: 11000,
                        uuid3: 6000,
                        uuid5: 39000,
                    },
                },
                {
                    name: "M-2023-11",
                    values: {
                        uuid1: 192000,
                        uuid2: 6500,
                        uuid3: 12000,
                        uuid5: 5900,
                    },
                },
                {
                    name: "M-2023-12",
                    values: {
                        uuid1: 184000,
                        uuid2: 2400,
                        uuid0: 35000,
                        uuid3: 12000,
                        uuid5: 5900,
                    },
                },
            ],
        },
        transactionTypes: [
            {
                id: "uuid1",
                name: "Faktura",
                direction: "INCOME",
                amount: 2340000,
            },
            {
                id: "uuid2",
                name: "Náklad",
                direction: "EXPENDITURE",
                amount: 439000,
            },
            {
                id: "uuid20",
                name: "Výplata zaměstnanci",
                direction: "EXPENDITURE",
                amount: 439000,
            },
            {
                id: "uuid0",
                name: "Daň z příjmu",
                direction: "EXPENDITURE",
                amount: 439000,
            },
            {
                id: "uuid3",
                name: "Sociální pojištění",
                direction: "EXPENDITURE",
                amount: 439000,
            },
            {
                id: "uuid5",
                name: "Zdravotní pojištění",
                direction: "EXPENDITURE",
                amount: 439000,
            },
        ],
    };
};

export const fetchEmployeeDetail = async (id) => {
    console.log("fetching detail", id);
    const [type] = id.split("-");
    await wait(1234);
    switch (type) {
        case "invoice":
            return { id };
        case "expense":
            return { id };
        default:
            return { id };
    }
};

export const saveEmployee = async (data) => {
    await wait(3402);
};
